import { cn } from "@base/lib/utils";
import { PLAN_ICON_SRC } from "@features/membership/config/constants";
import { useTranslation } from "react-i18next";
import type { BillingCycle, MembershipPlanType } from "../model/types";

const PLAN_STYLES: Record<
  Exclude<MembershipPlanType, "VIRTUAL_ADDRESS" | "DAY_PASS">,
  { bg: string; border: string }
> = {
  SILVER: { bg: "bg-gray-10", border: "border-gray-200" },
};

export interface MembershipPlanProps {
  type: MembershipPlanType;
  billing_cycle: BillingCycle;
  amount: string;
}

export function MembershipPlan({ type, billing_cycle, amount }: MembershipPlanProps) {
  const { t } = useTranslation();
  const typeLabel = t(`membershipPlan_${type}`);

  // Day Pass / Virtual Address: 아이콘·요금 표기 없이 플랜명만 노출 (Figma)
  if (type === "VIRTUAL_ADDRESS" || type === "DAY_PASS") {
    return (
      <div className="flex items-center p-4 border border-gray-200 rounded-8 bg-gray-10">
        <span className="text-title5 font-semibold text-gray-1000 leading-[130%] tracking-[-0.4px]">{typeLabel}</span>
      </div>
    );
  }

  const { bg, border } = PLAN_STYLES[type];
  const billingLabel = t(`billingCycle_${billing_cycle}`);

  return (
    <div className={cn("flex flex-row gap-4 p-4 border rounded-8", border, bg)}>
      <div className="flex shrink-0">
        <img src={PLAN_ICON_SRC[type]} alt="" className="w-12 h-12" />
      </div>
      <div className="flex flex-col flex-1 gap-1 justify-between min-w-0">
        <span className="text-subtitle4 text-gray-1000">{typeLabel}</span>
        <span className="text-gray-900 text-body3">{t("rateOf", { billingCycle: billingLabel, amount })}</span>
      </div>
    </div>
  );
}
